import React, {Fragment, useEffect, useState, useRef } from 'react'
import withFloor from '../../../components/withFloor'
import G from '../../../util/globalFunction'
import agencyLogo1 from '../../../static/images/common/agency_khu.jpg'
import agencyLogo2 from '../../../static/images/common/agency_krf.jpg'
import agencyLogo3 from '../../../static/images/common/agency_seoulTech.jpg'
import agencyLogo4 from '../../../static/images/common/agency_uos.jpg'
import agencyLogo5 from '../../../static/images/common/agency_kbsi.jpg'
import agencyLogo6 from '../../../static/images/common/agency_kricp.jpg'
import TF from '../../../util/tremFunction'

const WrappedPage = props  =>{

    //스크롤 이벤트
    const [scrollFlag, setScrollFlag] = useState(false)
    const scrollRef = useRef(scrollFlag)
    const onScroll = () => {
        if(window.scrollY > 200 && !scrollRef.current) {
            setScrollFlag(true)
            scrollRef.current = true
        }
        if(window.scrollY <= 200 && scrollRef.current) {
            setScrollFlag(false)
            scrollRef.current = false
        }
    }

    let toggle = "Y"
    useEffect(() => {
        window.addEventListener('scroll', onScroll)
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    return(
        <div className="sub_wrap">
            <div className={"navi_menu navi_menu2"+ (scrollFlag ? "fixed" : "")}>
                <div className="inner">
                    <ul>
                        <li className="navi_home">
                            <a href="javascript:void(0);" onClick={()=>{G.gotoPage(`/`)}} onFocus={() => {document.getElementById("header").style.height = "110px"}}>{G.t('trem.lang.home.0000')}</a>{/* 홈 */}
                        </li>
                        <li className="navi_first">
                            <a href="javascript:void(0);" onClick={()=>{G.gotoPage(`/location/main`)}}>{G.t('trem.lang.home.0399')}</a>{/* 서울바이오허브 */}
                            <div>
                                <a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/equip/reserv/list")}}>{G.t('trem.lang.home.0682')}</a>
                                <a href="javascript:void(0);" onClick={()=>{G.gotoPage(`/home/event/list`)}}>{G.t('trem.lang.home.0018')}</a>{/* 교육/세미나 */}
                                <a href="javascript:void(0);" onClick={()=>{G.gotoPage(`/home/board/notice/list`)}}>{G.t('trem.lang.home.0017')}</a>{/* 공지사항 */}
                            </div>
                        </li>
                        <li>
                            <a href="javascript:void(0);" onClick={()=>{G.gotoPage("/home/equipRoom/list")}}>{G.t('trem.lang.home.0469')}</a>{/* 유관기관 */}
                            <div>
                                <a href="javascript:void(0);" onClick={()=>{G.gotoPage("/location/main")}}>{G.t('trem.lang.home.0398')}</a>{/*시설안내(찾아오시는길)*/}
                                <a href='https://www.seoulbiohub.kr/front/supportManageReq/supportManageListPage.do'>{G.t('trem.lang.home.0695')}</a>{/* 주요지원사업 */}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>         
            <div className="inner" id="skip_con">
                <div className="location">
                    <p>{G.t('trem.lang.home.0000')}{' > '}{G.t('trem.lang.home.0399')}{' > '}{G.t('trem.lang.home.0469')}</p>{/* 홈 > 서울바이오허브 > 유관기관 */}
                    {/*
                    <ol>
                        <li>{G.t('trem.lang.home.0000')}</li>// 홈
                        <li>{G.t('trem.lang.home.0399')}</li>// 서울바이오허브
                        <li>{G.t('trem.lang.home.0469')}</li>// 유관기관
                    </ol>
                    */}
                    <h2>{G.t('trem.lang.home.0469')}</h2>{/* 유관기관 */}
                    <div className="btn_box" >
                         <a title="링크복사" className="btn_link" href="javascript:void(0);" onClick ={() => TF.getPublicAddress("/home/equipRoom/list")}>링크복사</a>
                         {/* <a className="btn_help" onClick ={() => TF.goHelp()}>도움말</a> */}
                    </div>
                </div>
                <div className="agency_wrap">   
                    <ul>
                        <li>
                            <div className="img_box">
                                <img src={agencyLogo1} alt="경희대학교 중앙기기센터"/>
                            </div>
                            <div className="text_box">
                                <a href="http://clia.khu.ac.kr/" target="_blank" rel="noopener noreferrer">경희대학교 중앙기기센터</a>
                            </div>
                        </li>
                        <li>
                            <div className="img_box">
                                <img src={agencyLogo2} alt="고려대학교 공동기기종합정보"/>
                            </div>
                            <div className="text_box">
                                <a href="https://krf.korea.ac.kr" target="_blank" rel="noopener noreferrer">고려대학교 공동기기종합정보</a>
                            </div>
                        </li>
                        <li>
                            <div className="img_box">
                                <img src={agencyLogo3} alt="서울과학기술대학교 공동실험실습관"/>
                            </div>
                            <div className="text_box">
                                <a href="http://lab.seoultech.ac.kr" target="_blank" rel="noopener noreferrer">서울과학기술대학교 공동실험실습관</a>
                            </div>
                        </li>
                        <li>
                            <div className="img_box">
                                <img src={agencyLogo4} alt="서울시립대학교 공동기기센터"/>
                            </div>
                            <div className="text_box">
                                <a href="http://crf.uos.ac.kr" target="_blank" rel="noopener noreferrer">서울시립대학교 공동기기센터</a>
                            </div>
                        </li>
                        <li>
                            <div className="img_box">
                                <img src={agencyLogo5} alt="한국기초과학지원연구원 장비활용포털"/>
                            </div>
                            <div className="text_box">
                                <a href="https://use.kbsi.re.kr/html/user/index.php" target="_blank" rel="noopener noreferrer">한국기초과학지원연구원 장비활용포털</a>
                            </div>
                        </li>
                        <li>
                            <div className="img_box">
                                <img src={agencyLogo6} alt="한국원자력의학원 국가RI신약센터"/>
                            </div>
                            <div className="text_box">
                                <a href="https://www.kricp.re.kr/index.do" target="_blank" rel="noopener noreferrer">한국원자력의학원 국가RI신약센터</a>
                            </div>
                        </li>
                    </ul>
                </div>                                 
            </div>
        </div>     
    )
}

const layout = true
const title = G.t('trem.lang.home.0682') + " > " +  G.t('trem.lang.home.0469') /* 시설·장비 예약 > 유관기관 */
const pageMode = 'find'
const layoutMode = 'public'

export default withFloor({ layout, title, pageMode, layoutMode })(WrappedPage)